var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-white is-large",attrs:{"disabled":_vm.downloading},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"mr-5 is-size-6 is-inline-block"},[_vm._v(" "+_vm._s(_vm.downloading ? this.$t("simulator.downloading") : this.$t("simulator.download"))+" ")]),_c('span',{staticClass:"icon ml-2 is-size-6"},[_c('span',{class:['fa', {
      'fa-download': !_vm.downloading,
      'fa-spin fa-spinner': _vm.downloading,
    }]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }